import { Box, Grid } from "@mui/material";

const FormSection = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Box
      sx={{
        fontWeight: 600,
        fontSize: "16px",
        mb: 2,
        borderBottom: "1px solid #eee",
        pb: 1
      }}
    >
      {title}
    </Box>
    <Grid container spacing={2}>{children}</Grid>
  </Box>
);

export default FormSection;
